
import React, { memo } from 'react'
import css from '../Modulecss/Home.module.css'
import acceptSound from './accept.mp3'
import findGif from '../css/loading_old.gif'
import playSound from './play.mp3'
import { useHistory } from 'react-router-dom'
import { FaTrash, FaUserCircle, FaChevronRight } from 'react-icons/fa'

const BetCard = React.memo(
  ({
    allgame,
    user,
    deleteChallenge,
    getPost,
    challangeReqRun,
    RejectGame,
    winnAmount,
    AcceptChallang,
    updateChallenge,
  }) => {
    const history = useHistory()
    const [disable, setDisable] = React.useState(challangeReqRun)
    const [disable_play, setDisable_play] = React.useState(false)

    const req_chall_fun = (allgameId) => {
      getPost(allgameId)
    }

    const disablebtn = () => {
      setDisable(true)
      setTimeout(() => {
        setDisable(false)
      }, 3000)
    }

    const disable_play_btn = () => {
      setDisable_play(true)
      setTimeout(() => {
        setDisable_play(false)
      }, 3000)
    }

    return (
      <>
        <style>
          {`
            @keyframes slideInLeft {
              0% { transform: translateX(-100%); opacity: 0; }
              100% { transform: translateX(0); opacity: 1; }
            }

            .premium-card {
              animation: slideInLeft 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) forwards;
              background: url('/images/test.avif') no-repeat center center;
              background-size: cover;
              border: 1px solid #1e252e;
              border-radius: 8px;
              margin-bottom: 10px;
              overflow: hidden;
              position: relative;
              font-family: 'Inter', sans-serif;
              width: 100%;
              min-height: 85px;
            }

            .card-header-top {
              padding: 6px 14px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-bottom: 1.5px solid rgba(255,255,255,0.1);
              position: relative;
              z-index: 1;
              background: rgba(0,0,0,0.2);
            }

            .challenge-text { color: #FFFF; font-size: 13px; font-weight: 500; }
            .creator-name { color: #76ff03; font-weight: 700; }

            .card-body-main {
              display: grid;
              grid-template-columns: 1.2fr 1fr 1.2fr;
              padding: 8px 14px;
              align-items: center;
              position: relative;
              z-index: 1;
            }

            .stat-box { display: flex; flex-direction: column; justify-content: center; }
            .stat-label { color: #ffffff; font-size: 11px; font-weight: 500; margin-bottom: 2px; opacity: 0.8; }
            .stat-value-container { display: flex; align-items: center; gap: 5px; }
            .coin-img { width: 18px; height: 18px; }
            .amount-val, .prize-val { color: #ffffff; font-size: 16px; font-weight: 800; }

            /* --- BUTTON VARIATIONS --- */
            .btn-base {
              border: none;
              padding: 6px 18px;
              font-weight: 800;
              font-size: 13px;
              cursor: pointer;
              transition: all 0.2s ease;
              clip-path: polygon(10% 0%, 90% 0%, 100% 50%, 90% 100%, 10% 100%, 0% 50%);
              text-transform: uppercase;
            }

            /* 1. PLAY BUTTON (Blue) */
            .play-btn-main { background: #007bff; color: white; }
            .play-btn-main:hover { background: #0056b3; }

            /* 2. START BUTTON (Green/Emerald) */
            .start-btn-main { background: #00c853; color: white; }
            .start-btn-main:hover { background: #00a844; }

            /* 3. REJECT BUTTON (Orange/Coral) */
            .reject-btn-main { background: #ff6d00; color: white; border-radius: 4px; clip-path: none; padding: 4px 10px; }
            
            /* 4. CANCEL BUTTON (Red) */
            .cancel-btn-main { background: #d50000; color: white; border-radius: 4px; clip-path: none; padding: 4px 10px; }

            .btn-base:active { transform: scale(0.9); }
            .btn-base:disabled { background: #455a64 !important; opacity: 0.6; cursor: not-allowed; }

            .footer-strip {
              background: rgba(0,0,0,0.3);
              padding: 4px 14px;
              display: flex;
              align-items: center;
              gap: 8px;
              border-top: 1px solid rgba(255,255,255,0.05);
            }
          `}
        </style>

        <div className="premium-card">
          <div className="card-header-top">
            <div className="challenge-text">
              Challange From <span className="creator-name">{allgame?.Created_by?.Name}</span>
            </div>
            {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
              <button
                style={{ color: '#ff4d4d', background: 'none', border: 'none', cursor: 'pointer' }}
                onClick={() => deleteChallenge(allgame?._id)}
              >
                <FaTrash size={14} />
              </button>
            )}
          </div>

          <div className="card-body-main">
            {/* Entry Fee Area */}
            <div className="stat-box">
              <span className="stat-label">Entry Fee</span>
              <div className="stat-value-container">
                <img src="/images/indiarupee.png" className="coin-img" alt="coin" />
                <span className="amount-val">{allgame?.Game_Ammount}</span>
              </div>
            </div>

            {/* Middle Action Button Area */}
            <div className="d-flex justify-content-center">
              {/* STATUS: NEW - OTHER USER SEES PLAY */}
              {user !== allgame?.Created_by?._id && allgame?.Status === 'new' && (
                <button
                  className="btn-base play-btn-main"
                  disabled={disable_play}
                  onClick={() => {
                    disable_play_btn()
                    AcceptChallang(allgame._id)
                  }}
                >
                  Play
                </button>
              )}

              {/* STATUS: NEW - CREATOR SEES FINDING */}
              {user === allgame?.Created_by?._id && allgame?.Status === 'new' && (
                <div className="text-center">
                  <img src={findGif} style={{ width: '18px' }} alt="loading" />
                  <div style={{ fontSize: '9px', color: '#76ff03', fontWeight: '900' }}>FINDING...</div>
                </div>
              )}

              {/* STATUS: REQUESTED - CREATOR SEES START/REJECT */}
              {user === allgame?.Created_by?._id && allgame?.Status === 'requested' && (
                <div className="d-flex gap-1">
                  <audio src={acceptSound} autoPlay></audio>
                  <button
                    className="btn-base start-btn-main"
                    style={{ padding: '4px 12px', fontSize: '11px' }}
                    disabled={disable}
                    onClick={() => { disablebtn(); req_chall_fun(allgame._id); }}
                  >
                    {disable ? 'WAIT...' : 'START'}
                  </button>
                  <button
                    className="btn-base reject-btn-main"
                    style={{ fontSize: '10px' }}
                    onClick={() => RejectGame(allgame._id)}
                  >
                    REJECT
                  </button>
                </div>
              )}

              {/* STATUS: REQUESTED - OTHER USER SEES CANCEL */}
              {user !== allgame?.Created_by?._id && allgame?.Status === 'requested' && (
                <div className="text-center">
                  <div className="badge bg-warning text-dark mb-1" style={{ fontSize: '8px' }}>PENDING</div>
                  <button
                    className="btn-base cancel-btn-main"
                    style={{ fontSize: '9px', width: '100%' }}
                    onClick={() => RejectGame(allgame?._id)}
                  >
                    CANCEL
                  </button>
                </div>
              )}

              {/* STATUS: RUNNING - USER SEES GO TO GAME */}
              {user !== allgame?.Created_by?._id && allgame?.Status === 'running' && (
                <button
                  disabled={disable}
                  className="btn-base start-btn-main d-flex align-items-center gap-1"
                  onClick={() => {
                    disablebtn()
                    updateChallenge(allgame._id)
                    history.push(`/viewgame1/${allgame._id}`)
                  }}
                >
                  <audio src={playSound} autoPlay></audio>
                  START <FaChevronRight size={10} />
                </button>
              )}
            </div>

            {/* Prize Area */}
            <div className="stat-box text-end align-items-end">
              <span className="stat-label" style={{ color: '#76ff03' }}>Prize</span>
              <div className="stat-value-container">
                <img src="/images/indiarupee.png" className="coin-img" alt="coin" />
                <span className="prize-val">
                  {allgame?.Game_Ammount + winnAmount(allgame?.Game_Ammount)}
                </span>
              </div>
            </div>
          </div>

          {/* Footer - Details */}
          {user === allgame?.Created_by?._id && allgame?.Status === 'requested' && (
            <div className="footer-strip">
              <span style={{ fontSize: '10px', color: '#aaa' }}>Opponent:</span>
              <div className="d-flex align-items-center gap-1">
                {allgame?.Accepetd_By?.avatar ? (
                  <img
                    src={`https://api.kakaking.in/${allgame.Accepetd_By.avatar}`}
                    alt="user"
                    style={{ width: '16px', height: '16px', borderRadius: '50%' }}
                  />
                ) : (
                  <FaUserCircle size={16} color="#76ff03" />
                )}
                <span style={{ fontSize: '11px', fontWeight: 'bold', color: '#fff' }}>
                  {allgame.Accepetd_By.Name}
                </span>
              </div>
            </div>
          )}
        </div>
      </>
    )
  }
)

export default memo(BetCard)